import Footer from "../../components/Footer/Footer";
import HeroSection from "../../components/Hero Section/HeroSection";
import Navbar from "../../components/Navbar/Navbar";

const Contact = () => {
  return (
    <div id="Contact">
      <Navbar />
      <HeroSection variant={3} />
      <Footer />
    </div>
  );
};

export default Contact;
